import React from 'react';
import logo from './logo.svg';
import './App.css';
import MainIcon from './MainIcon'
import Header from './Header'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Header />
        <MainIcon />
        <p>
          Under construction, please come back later!
        </p>
      </header>
    </div>
  );
}

export default App;
